/**
 * This function forms 3 sets (each consists of 2 lines) of lines which determine vanishing points
 * @param lines - lines from paving configurator (defined by user)
 * @param width - width of the photo
 * @param height - height of the photo
 * @returns three line segments
 */
export const lineSegments = function (lines, width, height) {
    // in the paving-configurator -- red
    let lineSegments1 = [[{
        "x": lines.fabric[0].point1.x / width,
        "y": lines.fabric[0].point1.y / height
    }, {
        "x": lines.fabric[0].point2.x / width,
        "y": lines.fabric[0].point2.y / height
    }], [{
        "x": lines.fabric[1].point1.x / width,
        "y": lines.fabric[1].point1.y / height
    }, {
        "x": lines.fabric[1].point2.x / width,
        "y": lines.fabric[1].point2.y / height
    }]];

    // in the paving-configurator -- green
    let lineSegments2 = [[{
        "x": lines.fabric[4].point1.x / width,
        "y": lines.fabric[4].point1.y / height
    }, {
        "x": lines.fabric[4].point2.x / width,
        "y": lines.fabric[4].point2.y / height
    }], [{
        "x": lines.fabric[5].point1.x / width,
        "y": lines.fabric[5].point1.y / height
    }, {
        "x": lines.fabric[5].point2.x / width,
        "y": lines.fabric[5].point2.y / height
    }]];
    // in the paving-configurator -- blue
    let lineSegments3 = [[{
        "x": lines.fabric[2].point1.x / width,
        "y": lines.fabric[2].point1.y / height
    }, {
        "x": lines.fabric[2].point2.x / width,
        "y": lines.fabric[2].point2.y / height
    }], [{
        "x": lines.fabric[3].point1.x / width,
        "y": lines.fabric[3].point1.y / height
    }, {
        "x": lines.fabric[3].point2.x / width,
        "y": lines.fabric[3].point2.y / height
    }]];

    return [lineSegments1, lineSegments2, lineSegments3];
}

export const lineIntersection = function (line1, line2) {
    let d1 = distance(line1[0], line1[1]);
    let d2 = distance(line2[0], line2[1]);

    let epsilon = 1e-8;
    if (Math.abs(d1) < epsilon || Math.abs(d2) < epsilon) {
        return null
    }

    let x1 = line1[0].x;
    let y1 = line1[0].y;

    let x2 = line1[1].x;
    let y2 = line1[1].y;

    let x3 = line2[0].x;
    let y3 = line2[0].y;

    let x4 = line2[1].x;
    let y4 = line2[1].y;

    let denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
    if (Math.abs(denominator) < epsilon) {
        return null;
    }

    return {
        x: ((x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4)) / denominator,
        y: ((x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4)) / denominator
    }
}

const distance = function (p1, p2) {
    let dx = p1.x - p2.x;
    let dy = p1.y - p2.y;
    return Math.sqrt(dx * dx + dy * dy);
}

export const imagePlaneToRelative = function (point, imageWidth, imageHeight) {
    let imageAspect = imageWidth / imageHeight;
    console.log(imageAspect, imageWidth, imageHeight)
    if (imageAspect <= 1) {
        // tall image. [-aspect, aspect] x [-1, 1] => [0, 1] x [0, 1]
        return {
            x: 0.5 * (point.x / imageAspect + 1),
            y: 0.5 * (-point.y + 1)
        }
    } else {
        // wide image. [-1, 1] x [-1 / aspect, 1 / aspect] => [0, 1] x [0, 1]
        return {
            x: 0.5 * (point.x + 1),
            y: 0.5 * (-point.y * imageAspect + 1)
        }
    }
}

export const relativeToImagePlane = function (point, imageWidth, imageHeight) {
    let aspectRatio = imageWidth / imageHeight;
    if (aspectRatio <= 1) {
        // tall image. [0, 1] x [0, 1] => [-aspect, aspect] x [-1, 1]
        return {
            x: (-1 + 2 * point.x) * aspectRatio,
            y: 1 - 2 * point.y
        }
    } else {
        // wide image. [0, 1] x [0, 1] => [-1, 1] x [-1 / aspect, 1 / aspect]
        return {
            x: -1 + 2 * point.x,
            y: (1 - 2 * point.y) / aspectRatio
        }
    }
}

export const triangleOrthoCenter = function (k, l, m) {
    let a = k.x;
    let b = k.y;
    let c = l.x;
    let d = l.y;
    let e = m.x;
    let f = m.y;

    let N = b * c + d * e + f * a - c * f - b * e - a * d;
    let x = ((d - f) * b * b + (f - b) * d * d + (b - d) * f * f + a * b * (c - e) + c * d * (e - a) + e * f * (a - c)) / N;
    let y = ((e - c) * a * a + (a - e) * c * c + (c - a) * e * e + a * b * (f - d) + c * d * (b - f) + e * f * (d - b)) / N;

    return {
        x: x, y: y
    };
}
